import {
  type FormCheckboxProps,
  FormCheckbox,
  FormRadio,
  FormRadioProps,
  VisuallyHidden,
} from "@ariakit/react";
import * as style from "./style.css";

function CheckmarkSymbol() {
  return (
    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
      <g strokeWidth="1.25" fill="none" strokeLinecap="square">
        <line x1="4" y1="4" x2="10" y2="10" className={style.line1} />
        <line x1="10" y1="4" x2="4" y2="10" className={style.line2} />
      </g>
    </svg>
  );
}

export function CheckboxField(props: FormCheckboxProps & { label: string }) {
  const { label, ...checkboxProps } = props;

  return (
    <label className={style.container}>
      <VisuallyHidden>
        <FormCheckbox {...checkboxProps} />
      </VisuallyHidden>

      <span className={style.checkboxSymbol()}>
        <CheckmarkSymbol />
      </span>

      {label}
    </label>
  );
}

export function RadioField(props: FormRadioProps & { label: string }) {
  const { label, ...checkboxProps } = props;

  return (
    <label className={style.container}>
      <VisuallyHidden>
        <FormRadio {...checkboxProps} />
      </VisuallyHidden>

      <span className={style.checkboxSymbol({ rounded: true })}>
        <CheckmarkSymbol />
      </span>

      {label}
    </label>
  );
}
